module.exports = __webpack_public_path__ + "static/img/explorer_256.e2c4f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/explorer_256.png
// module id = H4sV
// module chunks = 0